import { render } from "./PermissionSetting.vue?vue&type=template&id=02b4ccc8"
import script from "./PermissionSetting.vue?vue&type=script&lang=js"
export * from "./PermissionSetting.vue?vue&type=script&lang=js"

import "./PermissionSetting.vue?vue&type=style&index=0&id=02b4ccc8&lang=less"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__